import { useCallback, useMemo } from 'react';
import { useDataProvider } from 'react-admin';
import { isImperialUnitMeasurement } from 'services/helpers/unitsMeasurement';
import { getWeightOzValue, getWeightGmValue } from 'services/helpers/convertWeight';

const useCreatePreset = () => {
  const dataProvider = useDataProvider();

  const isImperial = useMemo(() => isImperialUnitMeasurement(), []);

  const preparePresetData = useCallback(
    ({ packageName, packageInfo, packageType }) => {
      const {
        size: { height, length, width },
        weight: { oz: weightOz, lb: weightLb, gm: weightGm, kg: weightKg },
      } = packageInfo;

      const weightOzValue = getWeightOzValue(weightLb, weightOz);
      const weightGmValue = getWeightGmValue(weightKg, weightGm);

      return {
        name: packageName,
        height,
        length,
        width,
        packageType,
        ...(isImperial ? { weightOz: weightOzValue } : { weightGm: weightGmValue }),
      };
    },
    [isImperial]
  );

  const createPreset = useCallback(
    (data) => {
      const requestData = preparePresetData(data);

      return dataProvider.create('shippingPresets', { data: requestData });
    },
    [dataProvider, preparePresetData]
  );

  return createPreset;
};

export default useCreatePreset;
